import { ContentSchema, type Content } from './schemas';
import rawIndex from './index.generated';

const content: Content = ContentSchema.parse(rawIndex);

export function useContent(): Content {
  return content;
}

export function getContent(): Content {
  return content;
}

export function useStrategy(id: string) {
  const s = content.strategies.find((x) => x.id === id);
  if (!s) throw new Response('Not found', { status: 404 });
  return s;
}

export function useArticle(id: string) {
  const a = content.articles.find((x) => x.id === id);
  if (!a) throw new Response('Not found', { status: 404 });
  return a;
}

export function useTier(id: string) {
  const t = content.tiers.find((x) => x.id === id);
  if (!t) throw new Response('Not found', { status: 404 });
  return t;
}

export function usePage(slug: string) {
  const p = content.pages[slug];
  if (!p) throw new Response('Not found', { status: 404 });
  return p;
}
